<template>
  <div class="pa-5" id="summary">
   <!--タイトル-->
    <span class="subHead">
    {{ title }}
    </span>
    <v-icon
    class="mb-2"
    color="blue-grey darken-2">
      {{ icon }}
    </v-icon>
    <!--内容-->
 <div class="row">
<v-col
      xs="12"
      sm="12"
      md="7"
      lg="7"
      xl="7"
>
 <v-card-text class="summary">
                {{ description }}
          </v-card-text>
          </v-col>
<v-col
      xs="12"
      sm="12"
      md="5"
      lg="5"
      xl="5">
              <v-img :src="src"></v-img>
              </v-col>
</div>
</div>
</template>

<style>
.subHead {
  font-size: 25px;
}
.head2 {
  font-size: 20px;
  border-left: inset 6px#99CCFF;
  padding-left: 8px;
  margin-bottom: 8px;
}
.summary {
  vertical-align: middle;
  font-size: 16px;
}
</style>

<script>
export default {
  data () {
    return {
      // タイトル
      title: '概要',
      // タイトル横のアイコン
      icon: 'mdi-message-bulleted',
      // 説明文
      description: '2005年から研究開発を開始し、国際学会(E-Learn)や医療情報学会で発表し研究者の意見をお伺いし、また実際の運用を通してユーザーからのフィードバックによってブラッシュアップしてきました。手間のかからないビデオ作成、コンテンツの全文検索、コンテンツの保護が特徴です。またゼロから開発を行っていますので、低コストでカスタマイズ可能です。',
      // 画像
      src: require('../../assets/Products/elearning.png')
    }
  }
}
</script>
